import createStoreWithContext from '@/utils/store/create-store-with-context'

import ProgramApis from '../../apis'

const { withStore, useStore: usePrograms } = createStoreWithContext(
  (set, get, swrFields) => ({
    ...swrFields,
  }),
  (data) => ({
    key: `programs`,
    initialData: data,
    fetcher: () => ProgramApis.getAll(),
    storeKey: 'programs',
  }),
)

export const withProgramsStore = withStore

export default usePrograms
